export function round(num, scale) {
  return Number(+(Math.round(num + 'e+' + scale) + 'e-' + scale)).toFixed(scale);
}